import { ConfirmationModal } from 'app/shared/modal/confirmation-modal';
import React, { useState } from 'react';
import {
  updateAmendmentCaseActWithDefaultTemplateQuery,
  updateCaseActWithDefaultTemplateQuery
} from 'app/edozvola/cases/case-acts/service/case-acts.queries';
import CaseActRequestDescriptionModal from 'app/edozvola/cases/case-acts/case-act-request-description-modal';

export interface ICaseActsConfirmationModalProps {
  uuid: string;
  confirmActionModalShown: boolean;
  setConfirmActionModalShown: any;
  readOnly: boolean;
  onConfirmed?: (any) => void;
  header?: string;
  bodyMessage?: string;
  isAmendment?: boolean;
}

const CaseActsConfirmationModal = (props: ICaseActsConfirmationModalProps) => {
  const closeModal = () => {
    props.setConfirmActionModalShown(false);
  };

  const [caseActRequestDescriptionModalShown, setCaseActRequestDescriptionModalShown] = useState<boolean>(false);
  const { mutate: updateCaseActMutation, isPending } = props.isAmendment ?
    updateAmendmentCaseActWithDefaultTemplateQuery(props.uuid, (data) => {
        props.onConfirmed(data.idCaseAct);
        closeModal();
      })
    :
    updateCaseActWithDefaultTemplateQuery(props.uuid, (data) => {
    props.onConfirmed(data.idCaseAct);
    closeModal();
  });

  const onConfirmClicked = () => {
    setCaseActRequestDescriptionModalShown(true);
  };

  return (
    <>
      <ConfirmationModal
        modalOpened={props.confirmActionModalShown}
        header={props.header ?? 'Izrada dokumenta zahtjeva'}
        bodyMessage={
          props.bodyMessage ??
          'Izrada dokumenta zahtjeva je posljednji korak prije predaje zahtjeva. Nakon što izradite dokument zahtjeva, isti nećete moći izmijeniti ili izbrisati. Jeste li sigurni da želite izraditi dokument zahtjeva?'
        }
        onConfirm={() => onConfirmClicked()}
        onCancel={() => props.setConfirmActionModalShown(false)}
        confirmButtonLabel={'Nastavi s izradom dokumenta'}
        cancelButtonLabel={'Odustani'}
        loadingStateForConfirmationButton={isPending}
      />
      <CaseActRequestDescriptionModal
        modalShown={caseActRequestDescriptionModalShown}
        setModalShown={setCaseActRequestDescriptionModalShown}
        onSubmit={updateCaseActMutation}
      />
      </>
  );
};

export default CaseActsConfirmationModal;
